import { EoriNumber, IossNumber, TaxId, VatNumber, VatStatus } from '../smartsend/lib/consts/ItemMetaConstants';
import { useMemo } from 'react';
import {
  EoriNumberGbValidation,
  EoriNumberValidation,
  IossNumberValidation
} from '../smartsend/lib/consts/ItemMetaValidationConstants';

export interface CustomsField {
  key: string;
  label: string;
  translationKey?: string;
  validation?: string;
}

const useDefaultCustoms = (senderCountryIsoCode?: string) => {
  const defaultCustoms: CustomsField[] = useMemo(() => {
    const output = [
      {
        key: VatStatus,
        label: 'Tax Status',
        translationKey: 'VAT_STATUS_INPUT_LABEL'
      },
      {
        key: VatNumber,
        label: `{{taxName}} Number`,
        translationKey: `VAT_NUMBER_INPUT_LABEL`
      },
      {
        key: IossNumber,
        label: 'IOSS Number',
        translationKey: 'IOSS_NUMBER_INPUT_LABEL',
        validation: IossNumberValidation
      },
      {
        key: EoriNumber,
        label: 'EORI Number',
        translationKey: 'EORI_NUMBER_INPUT_LABEL',
        validation: senderCountryIsoCode?.startsWith('GBR') ? EoriNumberGbValidation : EoriNumberValidation
      },
      {
        key: TaxId,
        label: 'Tax ID',
        translationKey: 'TAX_ID_INPUT_LABEL'
      }
    ];

    return senderCountryIsoCode?.startsWith('GBR') ? output : output.filter((x) => x.key !== EoriNumber);
  }, [senderCountryIsoCode]);

  return defaultCustoms;
};

export default useDefaultCustoms;
